import * as React from "react";
const SvgFiRrEmployees = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-employees_svg__a)">
      <path
        fill="#062147"
        d="M13.5 12c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4m4-2c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M12 8c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4m0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2M6.5 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4m0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2m17.47 12.91a1 1 0 0 1-1.991.18 4.47 4.47 0 0 0-1.721-3.118c-.025-.02-.107-.011-.16.049l-1.841 2.133c-.19.22-.485.389-.757.347-.288 0-.562-.124-.752-.34l-1.865-2.126c-.051-.059-.133-.07-.16-.048a4.42 4.42 0 0 0-1.701 3.104c-.043.476-.413.82-.873.881-.03.005-.054.022-.084.025q-.046.003-.091.004c-.01 0-.018-.005-.027-.005q-.005.001-.011.001c-.011 0-.02-.008-.031-.009a.99.99 0 0 1-.926-.897 4.41 4.41 0 0 0-1.72-3.118c-.03-.021-.11-.011-.16.049l-1.841 2.133a1 1 0 0 1-1.509.006l-1.865-2.126c-.052-.058-.134-.069-.16-.047a4.42 4.42 0 0 0-1.702 3.104 1 1 0 0 1-1.992-.18 6.5 6.5 0 0 1 2.46-4.499c.876-.686 2.148-.552 2.897.303l1.107 1.262 1.09-1.263c.745-.865 2.019-1.007 2.9-.322A6.5 6.5 0 0 1 12 20.078a6.5 6.5 0 0 1 1.489-1.665c.874-.685 2.148-.553 2.897.304l1.107 1.261 1.09-1.263c.745-.865 2.02-1.005 2.899-.323a6.48 6.48 0 0 1 2.487 4.519z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-employees_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEmployees;
